
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Title from '../Title/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    Title
  }
})
export default class Book extends Vue {
  get PageStore() {
    return this.$store.$myV2.Classroom
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
